import { render, staticRenderFns } from "./GeneralLendger.vue?vue&type=template&id=6b1b5d9f&scoped=true&"
import script from "./GeneralLendger.vue?vue&type=script&lang=js&"
export * from "./GeneralLendger.vue?vue&type=script&lang=js&"
import style0 from "./GeneralLendger.vue?vue&type=style&index=0&id=6b1b5d9f&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6b1b5d9f",
  null
  
)

export default component.exports